/*----------------------
  SAMPLES POPUP
 ----------------------*/
window.SamplesPopup = {
  init: function () {
    function setCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + "; path=/; max-age=2592000; SameSite=Lax";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    $(".popup-samples").each(function () {
      var $popup = $(this);
      var popupElement = this;
      var delay = parseInt($popup.data("delay"), 10) || 15;
      var $header = $(".section-header").first();

      if (popupElement.samplesPopupTimer) {
        window.clearTimeout(popupElement.samplesPopupTimer);
      }
      if (popupElement.samplesPopupObserver) {
        popupElement.samplesPopupObserver.disconnect();
      }
      if (popupElement.samplesPopupHeaderObserver) {
        popupElement.samplesPopupHeaderObserver.disconnect();
      }

      $popup.off(".samplesPopup");

      function syncMobileTop() {
        if (!window.matchMedia("(max-width: 640px)").matches || !$header.length) {
          popupElement.style.removeProperty("--samples-popup-mobile-top");
          return;
        }

        var headerBottom = Math.max(0, Math.ceil($header[0].getBoundingClientRect().bottom));
        popupElement.style.setProperty("--samples-popup-mobile-top", (headerBottom + 6) + "px");
      }

      function syncPurchasePriority() {
        syncMobileTop();
        var ctaConflict = window.matchMedia("(max-width: 640px)").matches &&
          document.body.hasAttribute("data-sticky-atc-visible");
        $popup.toggleClass("popup-samples--cta-conflict", ctaConflict);
        $popup.attr("aria-hidden", (!$popup.hasClass("popup-samples-open") || ctaConflict).toString());
      }

      function openPopup() {
        $popup.addClass("popup-samples-open");
        syncPurchasePriority();
      }

      function closePopup(persist) {
        $popup.removeClass("popup-samples-open popup-samples--cta-conflict");
        $popup.attr("aria-hidden", "true");
        if (persist) setCookie("ssll-samples-popup", "1");
      }

      if (getCookie("ssll-samples-popup") !== "1") {
        popupElement.samplesPopupTimer = window.setTimeout(openPopup, delay * 1000);
      }

      if (window.MutationObserver) {
        popupElement.samplesPopupObserver = new window.MutationObserver(syncPurchasePriority);
        popupElement.samplesPopupObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ["data-sticky-atc-visible"]
        });
      }

      if ($header.length && window.ResizeObserver) {
        popupElement.samplesPopupHeaderObserver = new window.ResizeObserver(syncMobileTop);
        popupElement.samplesPopupHeaderObserver.observe($header[0]);
      }

      $popup.on("click.samplesPopup", ".popup-samples__close", function (event) {
        event.preventDefault();
        event.stopPropagation();
        closePopup(true);
      });

      $popup.on("click.samplesPopup", ".popup-samples__link", function () {
        setCookie("ssll-samples-popup", "1");
      });

      $popup.on("keydown.samplesPopup", function (event) {
        if (event.key === "Escape") closePopup(true);
      });

      syncPurchasePriority();
    });
  }
};

$(document).ready(function () {
  window.SamplesPopup.init();
});
$(document).on('shopify:section:load', function () {
  window.SamplesPopup.init();
});
